import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { CatalogApiComponent } from './catalog-api/catalog-api.component';
import { DataHealthComponent } from './datahealth/datahealth.component';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { DatahealthService } from './datahealth/datahealth.service';
import { CatalogManageComponent } from './catalog-manage/catalog-manage.component';
import { CatalogManageService } from './catalog-manage/catalog-manage.service';
import { NotificationsService } from 'angular2-notifications';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { Ng2CompleterModule } from 'ng2-completer';
import { InfohashComponent } from './infohash/infohash.component';
import { InfohashService } from './infohash/infohash.service';
import { ImageUpdateComponent } from './image-update/image-update.component';
import { ImageUpdateService } from './image-update/image-update.service';
import { TitleSearchBox } from '../shared/title-search-box/title.search.box.component';
import { BulkInfohashComponent } from '../bulk-infohash/bulk-infohash.component';
import { BsDatepickerModule, TooltipModule } from 'ngx-bootstrap';
import { SearchTitlesComponent } from './search-titles/search-titles.component';
import { CatalogSearchComponent } from './catalog-search/catalog-search.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { SearchTitlesService } from './search-titles/search-titles.service';
import { BulkTitleSearchComponent } from './bulk-title-search/bulk-title-search.component';
import { BulkActionsDropdownComponent } from './bulk-actions-dropdown/bulk-actions-dropdown.component';
import { QAService } from './qa/qa.service';
import { QAManageComponent } from './qa/qa-manage.component';
import { TitleRequestsModalComponent } from './title-requests-modal/title-requests-modal.component';
import { TitleRequestsService } from './title-requests/title-requests.service';
import { HarvestingComponent } from './harvesting/harvesting.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { AddToAccountModal } from './add-to-acount-modal/add-to-account-modal.component';
import { SchedulingComponent } from './scheduling/scheduling.component';
import { SchedulingService } from './scheduling/scheduling.service';
import { DiscoveryService } from './discovery/discovery.service';
import { DiscoveryComponent } from './discovery/discovery.component';
import {GlobalSearchTitlesComponent} from '../global-search/global-search-titles.component';
import {GlobalSearchResultsComponent} from '../global-search/global-search-results.component';
import {ChartsModule} from 'ng2-charts';
import {TrailerService} from './trailers/trailer.service';
import {TrailerComponent} from './trailers/trailer.component';
import {NgxSortableModule} from 'ngx-sortable';
import {VerificationSearchTitlesComponent} from '../catalog-verification/search-titles/verification-search-titles.component';
import {VerificationSearchResultsComponent} from '../catalog-verification/search-results/verification-search-results.component';
import {VerificationCatalogManageComponent} from '../catalog-verification/catalog-manage/verification-catalog-manage.component';
import {VerificationCatalogManageService} from '../catalog-verification/catalog-manage/verification-catalog-manage.service';
import {BusinessOperationsSearchTitlesComponent} from '../business-operations/business-operations-search-titles.component';
import {BusinessOperationsSearchResultsComponent} from '../business-operations/business-operations-search-results.component';
import {BusinessOperationsCatalogManageComponent} from '../business-operations/business-operations-catalog-manage.component';
import {JustwatchIdFetchSearchTitlesComponent} from '../justwatch-id-fetch/justwatch-id-fetch-search-titles.component';
import {JustwatchIdFetchSearchResultsComponent} from '../justwatch-id-fetch/justwatch-id-fetch-search-results.component';



@NgModule({
    declarations: [ CatalogApiComponent, DataHealthComponent, CatalogSearchComponent, CatalogManageComponent,
        InfohashComponent, ImageUpdateComponent, TitleSearchBox, BulkInfohashComponent,
        SearchTitlesComponent, VerificationSearchTitlesComponent, VerificationCatalogManageComponent, VerificationSearchResultsComponent, TrailerComponent, GlobalSearchTitlesComponent, BulkTitleSearchComponent, BulkActionsDropdownComponent, QAManageComponent, TitleRequestsModalComponent,
        HarvestingComponent, SearchResultsComponent, GlobalSearchResultsComponent, AddToAccountModal, SchedulingComponent, DiscoveryComponent,
        BusinessOperationsSearchTitlesComponent, BusinessOperationsSearchResultsComponent, BusinessOperationsCatalogManageComponent, JustwatchIdFetchSearchTitlesComponent, JustwatchIdFetchSearchResultsComponent
    ],
    exports: [CatalogApiComponent, CatalogSearchComponent, CatalogManageComponent, SearchTitlesComponent, GlobalSearchTitlesComponent, TitleSearchBox],
    imports: [BrowserModule,
        HttpModule, NgxSortableModule,
        FormsModule,
        SharedModule,
        SimpleNotificationsModule.forRoot(),
        BootstrapModalModule,
        Ng2CompleterModule,
        BsDatepickerModule.forRoot(),
        CollapseModule.forRoot(),
        TooltipModule.forRoot(), ChartsModule],
    providers: [DatahealthService, TrailerService,
        CatalogManageService,
        NotificationsService,
        InfohashService,
        ImageUpdateService,
        SearchTitlesService,
        QAService, TitleRequestsService,
        VerificationCatalogManageService,
        SchedulingService,
        DiscoveryService]
})
export class CatalogModule {
}



// WEBPACK FOOTER //
// ./src/app/catalogue/catalog.module.ts